import React from 'react'

import {
  EuiTitle,
  EuiSpacer,
  EuiFlexGroup,
  EuiFlexItem,
  EuiHorizontalRule,
  EuiHideFor
} from '@elastic/eui'

import IntroCards from './IntroCloudExtensionsToC'
import IntroCardsMobile from './IntroCloudExtensionsToC_mobile'

export default function IntroExtensions() {

  return (
    <React.Fragment>
      <EuiSpacer />
        <EuiTitle size="s">
            <h3>Übersicht</h3>
        </EuiTitle>
        <EuiTitle size="s">
            <h4>Verfügbare Erweiterungen für die INSTAR Cloud Platform</h4>
        </EuiTitle>
        <EuiHorizontalRule margin="xs" />
      <EuiFlexGroup gutterSize="l" direction="column" style={{margin: '0 7px'}} >
        <EuiFlexItem>
            <EuiHideFor sizes={['xs', 's', 'm', 'l']}>
              <IntroCards />
            </EuiHideFor>
            <EuiHideFor sizes={['xl']}>
              <IntroCardsMobile />
            </EuiHideFor>
        </EuiFlexItem>
    </EuiFlexGroup>
  </React.Fragment>
  );
}